
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 3.6v12.6c0 .993.897 1.8 2 1.8h14c1.103 0 2-.807 2-1.8V3.6c0-.993-.897-1.8-2-1.8h-2V0h-2v1.8H6V0H4v1.8H2c-1.103 0-2 .807-2 1.8zm16.001 12.6H1.999v-9h14.002v9zm0-10.8H1.999V3.6h14.002v1.8z","fill":"#585858"}})])
          )
        }
      }
    